<template>
    <div>
        <div class="container-fluid no-gutters w-container">
            <div class="row row-grid align-items-center">
                <div class="text-center">
                    <!--top Image -->
                    <figure class="w-100">
                        <img alt="Image placeholder" src="../../assets/img/exchange/topbg.jpg" class="img-fluid">
                    </figure>
                </div>
            </div>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#/exchange">两岸交流</a></li>
                    <li class="breadcrumb-item active" aria-current="page">详情</li>
                </ol>
            </nav>
            <iframe :src="path" width="100%" height="800px" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'newsDetail',
    data() {
        return {
            url: '',
        }
    },
    props: ["path"],

}
</script>

<style></style>